import axios from "../../../../axios";
import React, { useState } from "react";

const EditReplyLib = ({ setReply, reply, setClickEditReply, setEdited,userDetails,refetch }) => {
    console.log(reply);
    const [updateReply, setUpdateReply] = useState(reply.reply);
    const handleClick = async () => {
        
        if (updateReply.trim() !== '' || reply.attachments.length > 0) {
            try {
                let res = await axios.put(`/query/reply/update/${reply.id}`, {
                    user_id: userDetails.id,
                    reply: updateReply,
                    attachments: reply.attachments,
                });
                res && setClickEditReply();
                refetch()
            } catch (error) {
                console.log(error);
            }
        }
    };

    return (
        <>
            <div className="my-2 gap-3 d-flex align-items-center">
                <textarea
                    type="text"
                    value={updateReply}
                    onChange={(e) => setUpdateReply(e.target.value)}
                    className="edit_interface"
                />
                <div className="yes_no gap-4 d-flex">
                    <div className="done_discard" onClick={()=>{handleClick()}}>
                        <img src="/images/done.svg" alt="" />
                        <span>&nbsp; Done</span>
                    </div>

                    <div
                        className="done_discard"
                        onClick={(e) => setClickEditReply()}
                    >
                        <img src="/images/discard.svg" alt="" />
                        <span>&nbsp; Discard</span>
                    </div>
                </div>
            </div>
        </>
    );
};
export default EditReplyLib;
